import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import {
  deleteData,
  getAlert,
  insertData,
  updateData,
} from "../../../../utils/SamuiUtils";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataAPtype,
}) => {
  const [initialFormData, setInitialFormData] = useState({});
  
  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Prevent shortcuts when typing in input fields
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA' || event.target.tagName === 'SELECT') {
        return;
      }
      
      // ESC key - Cancel/Back
      if (event.key === 'Escape') {
        event.preventDefault();
        if (window.confirm('ต้องการยกเลิกการทำงานหรือไม่?')) {
          window.location.href = "/company";
        }
      }
      
      // F10 key - Save
      if (event.key === 'F10') {
        event.preventDefault();
        if (mode === 'I') return; 
        if (mode === 'U') {
          confirmAndUpdate();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        Comp_id: window.localStorage.getItem("company"), // Int
        Comp_Code: "",
        Comp_Name_TH: "",
        Comp_Name_EN: "",
        Comp_ShortName: "",
        Comp_TaxNo: "",
        Comp_Add1: "",
        Comp_Add2: "",
        Comp_Add3: "",
        Comp_Province: "",
        Comp_Post: "",
        Comp_Tel1: "",
        Comp_Tel2: "",
        Comp_Contact1: "",
        Comp_Contact2: "",
      };
      // กำหนดค่าเริ่มต้นให้กับ form data
      setFormData(initialData);
      // กำหนดค่าเริ่มต้นให้กับ initial form data
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        Comp_id: window.localStorage.getItem("company"), // Int
        Comp_Code: selectedData.Comp_Code,
        Comp_Name_TH: selectedData.Comp_Name_TH,
        Comp_Name_EN: selectedData.Comp_Name_EN,
        Comp_ShortName: selectedData.Comp_ShortName,
        Comp_TaxNo: selectedData.Comp_TaxNo,
        Comp_Add1: selectedData.Comp_Add1,
        Comp_Add2: selectedData.Comp_Add2,
        Comp_Add3: selectedData.Comp_Add3,
        Comp_Province: selectedData.Comp_Province,
        Comp_Post: selectedData.Comp_Post,
        Comp_Tel1: selectedData.Comp_Tel1,
        Comp_Tel2: selectedData.Comp_Tel2,
        Comp_Contact1: selectedData.Comp_Contact1,
        Comp_Contact2: selectedData.Comp_Contact2,
      };
      // อัปเดตค่าให้กับ form data
      setFormData(initialData);
      // อัปเดตค่าให้กับ initial form data
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  // ฟังก์ชันที่ใช้ในการเปลี่ยนค่าของข้อมูลในฟอร์ม
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleInsertAP = async () => {
    try {
      const { Comp_id, ...dataToInsert } = formData;
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      const res = await insertData("Tb_Set_Company", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error in handleInsertAP:", error);
      getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลได้");
    }
  };

  const formatValues = (data) => {
    const { Comp_id, ...rest } = data;
    return rest;
  };

  const handleUpdateAP = async () => {
    try {
      const where = { Comp_id: formData.Comp_id };
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_Company", values, where);
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize(selectedData?.Comp_Id);
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData(
            "Tb_Set_Company",
            `WHERE Comp_id = ${selectedData.Comp_id}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      })
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const confirmAndSubmit = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการบันทึกข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await handleSubmit();
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const confirmAndUpdate = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการแก้ไขข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await handleUpdateAP();
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = async (e) => {
    try {
      // if (
      //   !formData.ap_code ||
      //   !formData.ap_name ||
      //   !formData.ap_type ||
      //   !formData.ap_status
      // ) {
      //   getAlert(
      //     "WARNING",
      //     "โปรดกรอกข้อมูล รหัสเจ้าหนี้ ชื่อเจ้าหนี้  ประเภทเจ้าหนี้  สถานะ"
      //   );
      //   return;
      // }
      // ตรวจสอบว่าข้อมูลที่แก้ไขว่าซ้ำกับข้อมูลเดิมหรือไม่
      // if (
      //   formData.ap_code === initialFormData.ap_code &&
      //   formData.ap_name === initialFormData.ap_name &&
      //   formData.ap_type === initialFormData.ap_type &&
      //   formData.ap_shortname === initialFormData.ap_shortname &&
      //   formData.ap_taxno === initialFormData.ap_taxno &&
      //   formData.ap_add1 === initialFormData.ap_add1 &&
      //   formData.ap_add2 === initialFormData.ap_add2 &&
      //   formData.ap_add3 === initialFormData.ap_add3 &&
      //   formData.ap_province === initialFormData.ap_province &&
      //   formData.ap_zipcode === initialFormData.ap_zipcode &&
      //   formData.ap_contact === initialFormData.ap_contact &&
      //   formData.ap_contact2 === initialFormData.ap_contact2 &&
      //   formData.ap_tel === initialFormData.ap_tel &&
      //   formData.ap_tel2 === initialFormData.ap_tel2 &&
      //   formData.ap_group === initialFormData.ap_group &&
      //   formData.ap_refsalecode === initialFormData.ap_refsalecode &&
      //   formData.ap_area === initialFormData.ap_area &&
      //   formData.ap_status === initialFormData.ap_status &&
      //   formData.ap_credit === initialFormData.ap_credit &&
      //   formData.ap_vat === initialFormData.ap_vat &&
      //   formData.ap_discount === initialFormData.ap_discount &&
      //   formData.ap_branch === initialFormData.ap_branch &&
      //   formData.ap_bt_name === initialFormData.ap_bt_name
      // ) {
      //   getAlert(
      //     "WARNING",
      //     "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      //   );
      //   return;
      // }
      if (mode === "I") {
        await handleInsertAP();
      } else if (mode === "U") {
        await handleUpdateAP();
      }
      setFormData({
        comp_id: window.localStorage.getItem("company"), // Int
        Comp_Code: "",
        Comp_Name_TH: "",
        Comp_Name_EN: "",
        Comp_ShortName: "",
        Comp_TaxNo: "",
        Comp_Add1: "",
        Comp_Add2: "",
        Comp_Add3: "",
        Comp_Province: "",
        Comp_Post: "",
        Comp_Tel1: "",
        Comp_Tel2: "",
        Comp_Contact1: "",
        Comp_Contact2: "",
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/company" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container py-4">
        <div className="card shadow-sm">
          <div className="card-body">
            <h5 className="mb-3 border-bottom pb-2">ข้อมูลบริษัท</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <label>รหัสอ้างอิงบริษัท</label>
                <input type="text" className="form-control" name="Comp_Code" value={formData.Comp_Code || ""} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label>เลขภาษี</label>
                <input type="text" className="form-control" name="Comp_TaxNo" value={formData.Comp_TaxNo || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>ชื่อบริษัทภาษาไทย</label>
                <input type="text" className="form-control" name="Comp_Name_TH" value={formData.Comp_Name_TH || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>ชื่อบริษัทภาษาอังกฤษ</label>
                <input type="text" className="form-control" name="Comp_Name_EN" value={formData.Comp_Name_EN || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>ชื่อบริษัทแบบย่อ</label>
                <input type="text" className="form-control" name="Comp_ShortName" value={formData.Comp_ShortName || ""} onChange={handleChange} />
              </div>
            </div>

            <h5 className="mt-4 mb-3 border-bottom pb-2">ที่อยู่บริษัท</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <label>ที่อยู่ 1</label>
                <input type="text" className="form-control" name="Comp_Add1" value={formData.Comp_Add1 || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>ที่อยู่ 2</label>
                <input type="text" className="form-control" name="Comp_Add2" value={formData.Comp_Add2 || ""} onChange={handleChange} />
              </div>
              <div className="col-md-4">
                <label>ที่อยู่ 3</label>
                <input type="text" className="form-control" name="Comp_Add3" value={formData.Comp_Add3 || ""} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label>จังหวัด</label>
                <input type="text" className="form-control" name="Comp_Province" value={formData.Comp_Province || ""} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label>รหัสไปรษณีย์</label>
                <input type="text" className="form-control" name="Comp_Post" value={formData.Comp_Post || ""} onChange={handleChange} />
              </div>
            </div>

            <h5 className="mt-4 mb-3 border-bottom pb-2">ข้อมูลการติดต่อ</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <label>ติดต่อ</label>
                <input type="text" className="form-control" name="Comp_Contact1" value={formData.Comp_Contact1 || ""} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label>ติดต่อ 2</label>
                <input type="text" className="form-control" name="Comp_Contact2" value={formData.Comp_Contact2 || ""} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label>เบอร์โทร</label>
                <input type="text" className="form-control" name="Comp_Tel1" value={formData.Comp_Tel1 || ""} onChange={handleChange} />
              </div>
              <div className="col-md-6">
                <label>เบอร์โทร 2</label>
                <input type="text" className="form-control" name="Comp_Tel2" value={formData.Comp_Tel2 || ""} onChange={handleChange} />
              </div>
            </div>

            <div className="row mt-4">
              {mode !== "I" ? (
                <div className="d-flex justify-content-between align-items-center">
                  <button onClick={handleDelete} type="button" className="btn btn-danger btn-lg">ลบ</button>
                  <div className="d-flex gap-2">
                    <button onClick={() => (window.location.href = "/company")} type="button" className="btn btn-dark btn-lg">ยกเลิก</button>
                    <button onClick={confirmAndUpdate} type="button" className="btn btn-warning text-white btn-lg">บันทึก</button>
                  </div>
                </div>
              ) : (
                <div className="d-flex">
                  <FormAction onSubmit={handleSubmit} onUpdate={handleSubmit} onDelete={handleDelete} mode={mode} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
